export default "__VITE_ASSET__8350d403__"